import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownUserConnections = ( { control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, user_id, to_user_id, mode, teamFilter } ) =>
{
    const url = '/users/' + user_id + '/usersCanConnect?mode=' + mode + '&to_user_id=' + to_user_id + '&teamFilter=' + teamFilter ;

    const fields = { url: url, keyFieldName: 'user_id', labelFieldName: 'fullNameAndType', additionalFields: ['idusers', 'userTypeId'] }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownUserConnections;
